import { DocumentsProcessingCallout } from '../../components/DocumentsProcessingCallout';
import { StepIntro } from '../../components/StepIntro';
import { useManageIntegrationDataContext } from '../../context/manageIntegrationData.context';
import { useIntegrationProviderName } from '../../hooks/useIntegrationProviderName';
import { DirectHoldingsLinkPane } from './DirectHoldingsLinkPane';

/** Link existing Luminary direct holdings to integration data. */
export function LinkHoldingsStep() {
  const { directHoldingsLinkForm } = useManageIntegrationDataContext();
  const integrationProviderName = useIntegrationProviderName();

  return (
    <>
      <StepIntro
        title={`Link Luminary holding groups with ${integrationProviderName} data`}
        subtitle={`Sync ${integrationProviderName} data to Luminary direct holding groups`}
      />
      <DocumentsProcessingCallout />

      <DirectHoldingsLinkPane
        form={directHoldingsLinkForm}
        integrationProviderName={integrationProviderName}
      />
    </>
  );
}
